import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { mergeInitialValues } from '@utils/formik';
import { ClaimStatuses } from '@models/Claim';
import { selectClaim } from './selector';
import { useRouteParam } from '@hooks/params';
import { userClaimFetch } from './action';
import { useEffectOnce } from 'usehooks-ts';

const INITIAL_VALUES = {
  status: ClaimStatuses.Requested,
  note: '',
  totalClaimedAmount: 0,
  approvedAmount: 0,
};

export const useInitialValues = () => {
  const { claim } = useSelector(selectClaim);
  const dispatch = useDispatch();
  const claimableType = useRouteParam('claimableType');
  const claimableId = useRouteParam('claimableId');

  useEffectOnce(() => {
    dispatch(userClaimFetch({ claimableType, claimableId }));
  });

  return useMemo(() => {
    if (!claim) return INITIAL_VALUES;
    const { status, note, totalClaimedAmount, approvedAmount } = claim;
    return mergeInitialValues(INITIAL_VALUES, { status, note, totalClaimedAmount, approvedAmount });
  }, [claim]);
};
